enum SimType {
  UNSET_SIM_TYPE_NUM = 'UNSET_SIM_TYPE_NUM', // Do not use, needed because of proto3 limitations
  PHYSICAL = 'PHYSICAL',
  EMBEDDED = 'EMBEDDED',
}

export { SimType as SimsV2SimType };
